<template lang="pug">
  .search-tags
    .search-tags__content
      RoundedTag.search-tag(
        v-for="work in works"
        :key="work.id"
        v-if="work.results.length"
        :height="tagHeight"
        :class="{ 'search-tag--selected': isSelected(work) }"
        :text="work.title"
        :icon="work.thumbnail.url || ''"
        :baselineShift="0.04"
        @click="select(work)"
      )
</template>

<script>
import RoundedTag from '@/components/RoundedTag'

export default {
  components: {
    RoundedTag
  },

  props: {
    works: {
      type: Array,
      default: () => []
    },
    results: {
      type: Object,
      default: () => ({})
    },
    selected: {
      type: Object,
      default: () => ({})
    },
    tagHeight: {
      type: String,
      default: '48px'
    }
  },

  methods: {
    select(work) {
      this.$emit('select', work)
    },

    isSelected(work) {
      const { selected } = this
      return selected && selected.id === work.id
    }
  }
}
</script>

<style lang="scss">
@import '~@/settings';

.search-tags {
  width: 100%;
  overflow-x: scroll;
  @include hideScrollbar;

  &__content {
    display: flex;
    flex-direction: row;
  }
}

.search-tag {
  background: white;
  color: map-get($color, dark);
  font-size: 14px;
  font-weight: 400;
  margin-right: 0.6rem;
  white-space: nowrap;
  cursor: pointer;
  border: 1px solid #{map-get($border-color, light)};

  .rounded-tag__icon-wrapper {
    padding: 0.1rem;
  }

  &--selected {
    border-color: #d2e3fc;
    background: #e8f0fe;
  }
}
</style>
